export default {
  postCheck: (state) => {
    return state.postCheck;
  },

  loginCheck: (state) => {
    return state.loginCheck;
  },

  forgotCheck: (state) => {
    return state.forgotCheck;
  },
  forgotBtn: (state) => {
    return state.forgotBtn;
  },

  userProfile: state => {
    return state.userProfile;
  },


  loadingBtn: (state) => {
    return state.loadingBtn;
  },

  captcha: (state) => {
    return state.captcha;
  },


};
